export const SEARCH_RESTAURANTS = "SEARCH_RESTAURANTS";
export const CLEAR_SEARCH = "CLEAR_SEARCH";
